import React from 'react'

//
import { HeroDual as StorybookHeroDual, ButtonNew } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { MediaComponent } from '../crissCross/mediaComponent'
import { useNavigationData } from '@/src/context/NavigationContext'

const HeroDual = ({
  data: {
    preface,
    title,
    description,
    primaryAction,
    secondaryAction,
    image,
    wistiaVideo,
    logo,
    homepage,
    theme
  }
}) => {
  const location = React.useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location

  let search = null

  return (
    <StorybookHeroDual
      headingType="h1"
      eyebrow={preface}
      logo={logo?.svgIcon}
      title={title}
      text={description}
      search={search}
      prefaceBelow={false}
      homepage={homepage}
      media={<MediaComponent {...{ wistiaVideo, image }} />}
      theme={theme}
    >
      {primaryAction && (
        <div>
          <ButtonNew
            variant="green"
            url={getUrl({
              navItem: primaryAction,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
            icon={primaryAction?.icon || ''}
            subtext={primaryAction.subtext}
          >
            {primaryAction?.title || ''}
          </ButtonNew>
        </div>
      )}
      {secondaryAction && (
        <ButtonNew
          url={getUrl({
            navItem: secondaryAction,
            slugPrefix: slugPrefix,
            navigationItems: navigationItems
          })}
          icon={secondaryAction?.icon || ''}
          variant="secondary"
          subtext={secondaryAction.subtext}
        >
          {secondaryAction?.title || ''}
        </ButtonNew>
      )}
    </StorybookHeroDual>
  )
}

export default HeroDual
